export const transformResponseCustomsRequirements = customsRequirements => {
  return {
    needs_ns_pid: customsRequirements.needs_ns_pid,
    customs_country_codes: customsRequirements.customs_country_codes ?? [],
    importer_subsidiary_country_codes: customsRequirements.importer_subsidiary_country_codes ?? [],
  }
}
